import { useEffect, useRef, useState } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  getDrilldownTenant,
  getStatusRollup,
  postRecalcularTenant,
} from '../../../services/GestaoTenants/getGestaoTenants'

const POLL_INTERVALO_MS = 3000

export function useGestaoTenantDetalhe() {
  const navigate = useNavigate()
  const { tenantId } = useParams()

  const [drill, setDrill] = useState<DrilldownTenantType | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [dataInicio, setDataInicio] = useState('')
  const [dataFim, setDataFim] = useState('')
  const [granularidade, setGranularidade] = useState('DIA')
  const [recalculando, setRecalculando] = useState(false)

  const pollRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const montadoRef = useRef(true)
  const filtrosRef = useRef({ dataInicio, dataFim, granularidade })
  filtrosRef.current = { dataInicio, dataFim, granularidade }

  useEffect(() => {
    montadoRef.current = true
    return () => {
      montadoRef.current = false
    }
  }, [])

  const fetchDrill = async (source: any) => {
    if (!tenantId) return
    setIsLoading(true)
    const result = await getDrilldownTenant(
      source,
      tenantId,
      dataInicio,
      dataFim,
      granularidade
    )
    if ('message' in result) {
      if (result.message !== 'cancelToken') {
        toast.error(result.message)
      }
    } else {
      setDrill(result)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    const source = axios.CancelToken.source()
    fetchDrill(source)
    return () => source.cancel('cancelToken')
  }, [JSON.stringify({ tenantId, dataInicio, dataFim, granularidade })])

  const recarregar = async () => {
    if (!tenantId) return
    const {
      dataInicio: di,
      dataFim: df,
      granularidade: gr,
    } = filtrosRef.current
    const source = axios.CancelToken.source()
    const result = await getDrilldownTenant(source, tenantId, di, df, gr)
    if (!('message' in result) && montadoRef.current) {
      setDrill(result)
    }
  }

  const pollStatus = () => {
    pollRef.current = setTimeout(async () => {
      const source = axios.CancelToken.source()
      const result = await getStatusRollup(source)
      if (!montadoRef.current) return
      if ('message' in result) {
        pollStatus()
        return
      }
      if (result.emAndamento) {
        pollStatus()
      } else {
        setRecalculando(false)
        toast.success('Rollup atualizado.')
        recarregar()
      }
    }, POLL_INTERVALO_MS)
  }

  useEffect(() => {
    if (!recalculando) return undefined
    pollStatus()
    return () => {
      if (pollRef.current) clearTimeout(pollRef.current)
    }
  }, [recalculando])

  const recalcular = async () => {
    if (!tenantId || recalculando) return
    const result = await postRecalcularTenant(tenantId)
    if ('message' in result) {
      toast.error(result.message)
      return
    }
    setRecalculando(true)
    toast.info(result.mensagem)
  }

  const voltar = () => navigate('/adm-gestao-tenants')

  return {
    drill,
    isLoading,
    recalculando,
    granularidade,
    setGranularidade,
    onChangeDataInicio: setDataInicio,
    onChangeDataFim: setDataFim,
    recalcular,
    voltar,
  }
}
